<div fxLayout="row" class="background">
    <div fxFlex="80" fxFlexOffset="10%">

        <section id="header">
            <h1 class="h1Header">REPORTE DE VENTAS</h1>
        </section>

        <section id="table">
            <form [formGroup]="shopSalesReportForm">
                <mat-card class="mat-elevation-z0">

                    <div fxLayout="row wrap" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Fecha desde</mat-label>
                                <input (dateInput)="inpuDateFrom($event)" matInput [matDatepicker]="calendar">
                                <mat-datepicker-toggle matSuffix [for]="calendar"></mat-datepicker-toggle>
                                <mat-datepicker #calendar></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Fecha hasta</mat-label>
                                <input (dateInput)="inpuDateTo($event)" matInput [matDatepicker]="fhasta"
                                    format="yyyy-MM-dd">
                                <mat-datepicker-toggle matSuffix [for]="fhasta"></mat-datepicker-toggle>
                                <mat-datepicker #fhasta></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="status">
                                    <mat-option *ngFor="let option of statusOptions" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Método de Pago</mat-label>
                                <mat-select formControlName="payment">
                                    <mat-option *ngFor="let option of paymentOptions" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Entrega</mat-label>
                                <mat-select formControlName="isShipping">
                                    <mat-option *ngFor="let option of isShippingOptions" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <!-- <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Liquidación</mat-label>
                                <mat-select formControlName="liquidacion">
                                    <mat-option *ngFor="let option of liquidacionOptions" [value]="option.value">
                                        {{option.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div> -->

                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="0.5rem">
                        <div fxFlex="20">
                            <button mat-raised-button class="squared-btn"
                                (click)="previewReport(shopSalesReportForm.value)">Previsualizar</button>
                        </div>
                        <div fxFlex="20">
                            <button mat-raised-button class="squared-btn"
                                (click)="exporter.exportTable('xlsx')">Exportar
                                Excel</button>
                        </div>
                        <!-- <div fxFlex="20">
                            <button mat-raised-button class="squared-btn" (click)="exportPDF()">Exportar PDF</button>
                        </div> -->
                    </div>
                    <br>
                    <table mat-table matTableExporter [dataSource]="allOrders" #exporter="matTableExporter"
                        class="mat-elevation-z0">
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
                            <td mat-cell *matCellDef="let saleReport"> {{saleReport.cdOrder}} </td>
                        </ng-container>

                        <ng-container matColumnDef="client">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Cliente</th>
                            <td mat-cell *matCellDef="let saleReport"> {{saleReport.dsUserName}} </td>
                        </ng-container>

                        <ng-container matColumnDef="phone">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Teléfono</th>
                            <td mat-cell *matCellDef="let saleReport"> {{saleReport.dsPhone}} </td>
                        </ng-container>

                        <ng-container matColumnDef="address">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Dirección</th>
                            <td mat-cell *matCellDef="let saleReport"> {{saleReport.dsAddress}} </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Estado</th>
                            <td mat-cell *matCellDef="let saleReport"> {{saleReport.nmStatus | ordersStatus}} </td>
                        </ng-container>

                        <ng-container matColumnDef="total">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Total</th>
                            <td mat-cell *matCellDef="let saleReport" class="centered"> ${{saleReport.qtTotal | number:
                                '1.2-2'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="discount">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Descuento general</th>
                            <td mat-cell *matCellDef="let saleReport" class="centered"> ${{saleReport.qtDiscount |
                                number: '1.2-2'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="payment">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Pago</th>
                            <td mat-cell *matCellDef="let saleReport" class="centered"> {{saleReport.nmPaymentMethod |
                                paymentMethod}} </td>
                        </ng-container>

                        <ng-container matColumnDef="delivery">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Entrega</th>
                            <td mat-cell *matCellDef="let saleReport" class="centered"> {{saleReport.isShipping |
                                delivery}} </td>
                        </ng-container>

                        <!-- <ng-container matColumnDef="commission">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Comisión</th>
                            <td mat-cell *matCellDef="let saleReport" class="centered"> ${{saleReport.qtComision |
                                number: '1.2-2'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="liquidacion">
                            <th mat-header-cell *matHeaderCellDef class="table-header">Liquidación</th>
                            <td mat-cell *matCellDef="let saleReport" class="centered"> ${{saleReport?.qtTotal -
                                saleReport?.qtComision | number: '1.2-2'}}</td>
                        </ng-container> -->

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <br>
                    <mat-card fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="1rem">
                        <span>Cantidad de pedidos: {{totalRows}} </span>
                        <span>Total: ${{getTotal() | number: '1.2-2'}}</span>
                        <!-- <span>Total Comisión: ${{getTotalComision() | number: '1.2-2'}}</span>
                        <span>Total a liquidar: ${{getTotalLiquidation() | number: '1.2-2'}}</span> -->
                    </mat-card>

                </mat-card>
            </form>
        </section>
    </div>
</div>